(() => {
  const sections = document.querySelectorAll('[data-vrs-help-rows]');

  if (!sections.length) {
    return;
  }

  for (const section of sections) {
    const lightbox = section.querySelector('[data-vrs-help-lightbox]');
    const lightboxImage = section.querySelector('[data-vrs-help-lightbox-image]');
    const closeButton = section.querySelector('[data-vrs-help-lightbox-close]');
    const triggers = section.querySelectorAll('[data-vrs-help-lightbox-trigger]');
    const backButton = section.querySelector('[data-vrs-help-back]');

    if (backButton) {
      backButton.addEventListener('click', () => {
        if (window.history.length > 1) {
          window.history.back();
          return;
        }

        window.location.href = '/';
      });
    }

    if (!lightbox || !lightboxImage || !closeButton || !triggers.length) {
      continue;
    }

    const closeLightbox = () => {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('vrs-help-rows-lightbox-open');
      closeButton.blur();

      window.setTimeout(() => {
        lightbox.hidden = true;
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
      }, 180);
    };

    const openLightbox = (trigger) => {
      const image = trigger.getAttribute('data-vrs-help-image');
      const alt = trigger.getAttribute('data-vrs-help-alt') || '';

      if (!image) {
        return;
      }

      lightboxImage.src = image;
      lightboxImage.alt = alt;
      lightbox.hidden = false;
      document.body.classList.add('vrs-help-rows-lightbox-open');

      window.requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
      });
    };

    for (const trigger of triggers) {
      trigger.addEventListener('click', () => openLightbox(trigger));
    }

    closeButton.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  }
})();
